











































































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Prop, PropSync } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import {
  defaultSystemCode,
  HistoryCount,
  RequestReserveHistoryCount,
  LendGroupCount,
  SystemCode
} from '@/api'
import { InputDatePicker } from '@/components/molecules/InputDatePicker'
import { dataStore, systemCodeStore } from '@/utils/store-accessor'
import { InputCode } from '@/components/molecules/InputCode'
import { MaskPattern, UserDetailStateInfo } from '@/types'

export interface UserContentUsageSituationItem {
  lendTotalCount: number
  lendTotalLimit: number
  insideReadingCount: number
  reserveCount: number
  lostCount: number
  suspendReason: {
    input: string
    display: string
    errorMessage: string
  }
  suspendLimit: {
    input: string
    errorMessage: string
  }
  updatedDate: string
  lendDate: string
  remindDate: string
  remindExclude: {
    input: SystemCode
    errorMessage: string
  }
  remindTotal: number
  remindWay: SystemCode
  overdueCount: number
  lendCountList: LendGroupCount[]
  lendLatestCount: number
  lendLatestLimit: number
  lendCountHistory: HistoryCount[]
  studentLendCountHistory: HistoryCount[]
  remindCountHistory: HistoryCount[]
  reserveCountHistory: HistoryCount[]
  requestReserveCountHistory: RequestReserveHistoryCount[]
  cardLostUno: string
  cardLostCount: {
    input: string
    errorMessage: string
  }
  cardLostReissueDate: {
    input: string
    errorMessage: string
  }
  cardLostDate: {
    input: string
    errorMessage: string
  }
}

export const defaultUserContentUsageSituationItem = (): UserContentUsageSituationItem => ({
  lendTotalCount: 0,
  lendTotalLimit: 0,
  insideReadingCount: 0,
  reserveCount: 0,
  lostCount: 0,
  suspendReason: {
    input: '',
    display: '',
    errorMessage: ''
  },
  suspendLimit: {
    input: '',
    errorMessage: ''
  },
  updatedDate: '',
  lendDate: '',
  remindDate: '',
  remindExclude: {
    input: defaultSystemCode(),
    errorMessage: ''
  },
  remindTotal: 0,
  remindWay: defaultSystemCode(),
  overdueCount: 0,
  lendCountList: [],
  lendLatestCount: 0,
  lendLatestLimit: 0,
  lendCountHistory: [],
  studentLendCountHistory: [],
  remindCountHistory: [],
  reserveCountHistory: [],
  requestReserveCountHistory: [],
  cardLostUno: '',
  cardLostCount: {
    input: '0',
    errorMessage: ''
  },
  cardLostReissueDate: {
    input: '',
    errorMessage: ''
  },
  cardLostDate: {
    input: '',
    errorMessage: ''
  }
})

@Component({
  components: {
    InputCode,
    InputDatePicker
  }
})
export default class UserContentUsageSituation extends ComponentVue {
  @PropSync('item', {
    type: Object,
    required: true
  })
  inputItem!: UserContentUsageSituationItem

  @Prop({
    type: Object,
    required: true
  })
  state!: UserDetailStateInfo

  @Prop({
    type: Boolean,
    required: true
  })
  existsStudentGrade!: boolean

  @Prop({
    type: Number,
    required: true
  })
  height!: number

  get cssCustomProperty(): any {
    return {
      '--height': this.height + 'px'
    }
  }

  get numberOnlyMask(): string {
    return MaskPattern.NumberOnly
  }

  get remindExcludeItems(): SystemCode[] {
    return systemCodeStore.getRemindExclude
  }

  get displayStudentLendCountHistory(): boolean {
    return (
      dataStore.enabledSchool && this.state.isUser() && this.existsStudentGrade
    )
  }

  get displayRemindCountHistory(): boolean {
    return dataStore.displayUserPageRemindCountHistory
  }

  get displayReserveCountHistory(): boolean {
    return dataStore.displayUserPageReserveCountHistory
  }

  get enabledRequestReserve(): boolean {
    return dataStore.enabledRequestReserve
  }

  existsErrorMessage(errorMessage: string): boolean {
    return !!errorMessage
  }

  resetErrorMessage(obj: any): void {
    obj.errorMessage = ''
  }

  displayPrice(value: number): string {
    return `￥${value.toLocaleString()}`
  }
}
